import React from 'react';
import '../../style/venders.css';

const VendorView = ({ vendor, onClose }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="modal fade show d-block vendor-modal-overlay no-scrollbar">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content shadow-lg border-0 rounded-3">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">Supplier Details</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <div className="row g-4">
              <div className="col-md-6">
                <h6 className="text-muted">Name</h6>
                <p>{vendor.name || 'N/A'}</p>
              </div>
              <div className="col-md-6">
                <h6 className="text-muted">Email</h6>
                <p>
                  {vendor.email ? (
                    <a href={`mailto:${vendor.email}`} className="text-decoration-none">
                      {vendor.email}
                    </a>
                  ) : (
                    'N/A'
                  )}
                </p>
              </div>
              <div className="col-md-6">
                <h6 className="text-muted">Phone</h6>
                <p>
                  {vendor.phone ? (
                    <a href={`tel:${vendor.phone}`} className="text-decoration-none">
                      {vendor.phone}
                    </a>
                  ) : (
                    'N/A'
                  )}
                </p>
              </div>
              <div className="col-md-6">
                <h6 className="text-muted">Supplier ID</h6>
                <p className="text-muted">{vendor.id || 'N/A'}</p>
              </div>
              <div className="col-12">
                <h6 className="text-muted">Address</h6>
                <p>{vendor.address || 'No address provided'}</p>
              </div>
            </div>

            <hr />

            <div className="row g-4">
              <div className="col-md-6">
                <h6 className="text-muted">Created</h6>
                <p className="text-muted">{formatDate(vendor.createdAt)}</p>
              </div>
              <div className="col-md-6">
                <h6 className="text-muted">Last Updated</h6>
                <p className="text-muted">{formatDate(vendor.updatedAt)}</p>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorView;
